'use client';

import builder, { BuilderComponent, useIsPreviewing } from '@builder.io/react';
import { differenceInMonths } from 'date-fns';

import EmailSmsModal from '@/components/modal/EmailSmsModal/EmailSmsModal';
import '@/components/builder/component-registry';
import { useModal } from '@/components/hook/modal';
import { useLoggedInUser } from '@/components/hook/user';
import { useOnMount } from '@/components/hook/onMount';

type BuilderPageProps = {
  content: any;
  model: string;
  data?: any;
  context?: any;
};

function RenderBuilderContent(props: BuilderPageProps) {
  const { content, model, data, context } = props;
  const BUILDER_PUBLIC_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY;
  const today = new Date().toDateString();

  const isPreviewing = useIsPreviewing();
  const modalTools = useModal();
  const user = useLoggedInUser();
  let showEmailSmsModal = false;

  useOnMount(() => {
    if (typeof window !== 'undefined') {
      // Is user due to view modal? Either because they've never seen it before,
      // or because it's been at least a month since they've last seen it?
      let dueToViewModal = false;

      let emailSmsModalDismissedDate =
        localStorage.getItem('emailSmsModalDismissedDate') || null;

      if (!emailSmsModalDismissedDate) {
        dueToViewModal = true;
      } else {
        dueToViewModal =
          differenceInMonths(
            new Date(emailSmsModalDismissedDate),
            new Date(today)
          ) >= 1;
      }

      if (dueToViewModal) {
        if (user) {
          // If user is logged in and it's been a month since we saw them last
          // and they aren't opted in either email or sms, show modal
          if (!user.subscriptions.email || !user.subscriptions.sms) {
            showEmailSmsModal = false;
          }
        }
        // If user isn't logged in and it's been a month since we saw them last, show modal
        else {
          showEmailSmsModal = false;
        }
      }
    }

    if (showEmailSmsModal) {
      modalTools.showModal(<EmailSmsModal onClose={modalTools.closeModal} />, {
        topClassName: 'bg-gold'
      });
    }
  });

  builder.init(BUILDER_PUBLIC_API_KEY as string);

  if (content || isPreviewing) {
    return (
      <BuilderComponent
        content={content}
        model={model}
        data={data}
        context={context}
      />
    );
  }

  throw Error('No content');
}

export default RenderBuilderContent;
